import React from 'react'

const Knowledgeicon = () => {
    return (
        <div>
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.625 19C17.8312 19 18 18.8313 18 18.625V18.375C18 18.1687 17.8312 18 17.625 18H12.375C12.1688 18 12 18.1687 12 18.375V18.625C12 18.8313 12.1688 19 12.375 19H17.625Z" fill="#475969" />
                <path d="M17.625 17C17.8312 17 18 16.8313 18 16.625V16.375C18 16.1687 17.8312 16 17.625 16H12.375C12.1688 16 12 16.1687 12 16.375V16.625C12 16.8313 12.1688 17 12.375 17H17.625Z" fill="#475969" />
                <path d="M18 14.625V14.375C18 14.1687 17.8312 14 17.625 14H12.375C12.1688 14 12 14.1687 12 14.375V14.625C12 14.8313 12.1688 15 12.375 15H17.625C17.8312 15 18 14.8313 18 14.625Z" fill="#475969" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15 30C23.2842 30 30 23.2843 30 15C30 6.7157 23.2842 0 15 0C6.71582 0 0 6.7157 0 15C0 23.2843 6.71582 30 15 30ZM16 7V11.25C16 11.6625 16.3375 12 16.75 12H21V22.25C21 22.6656 20.6656 23 20.25 23H9.75C9.33435 23 9 22.6656 9 22.25V7.75C9 7.33435 9.33435 7 9.75 7H16ZM21 11V10.8093C21 10.6125 20.9219 10.4219 20.7812 10.2812L17.7219 7.21875C17.5812 7.07812 17.3906 7 17.1906 7H17V11H21Z" fill="#475969" />
            </svg>
        </div>
    )
}

export default Knowledgeicon
